import React, { useState } from 'react';
import {
    UsagePricingDataTableContainer,
    UsagePricingDataContainer,
    UsagePricingTableFont,
} from 'src/common/components/orderDetails/detailsDataTable/DetailsDataTable.styled';
import { useSelector } from 'react-redux';
import Datatable from 'src/common/refactoredComponents/dataTable/DataTable';
import BundleTag from 'src/common/components/orderDetails/bundleTag/BundleTag';
import CfnLabel from 'src/common/components/orderDetails/bundleCards/CfnLabel';
import SerialNoLabel from 'src/common/components/orderDetails/bundleCards/SerialNoLabel';
import ItemDescriptionLabel from 'src/common/components/orderDetails/bundleCards/ItemDescriptionLabel';
import PricingContainer from 'src/common/components/orderDetails/bundleCards/PricingContainer';
import BundleLayout from 'src/common/components/orderDetails/bundleCards/BundleLayout';
import { bundleRowToggleFunction, bundleArrowFunction, logErrorToConsole } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { useAdjQtyLabel } from 'src/common/hooks/useAdjQtyLabel';

const BillingSummaryDataTableEquity = ({
    data,
    keyValue,
    bundleSubGroup,
    rowExpand,
    updateRowExpandHandler,
    setItemHandler,
    isBundleTable,
}) => {
    const [orderType, setOrderType] = useState();
    const { t } = useTranslation();
    const resolveAdjLabel = useAdjQtyLabel();
    const { orderBasicDetails } = useSelector(
        (state) => state.orderSummaryReducer
    );
    useEffectWithErrorLogging(() => {
        setOrderType(orderBasicDetails?.currentOrderType);
    }, []);
    let colData = [
        {
            field: 'cfn',
            header: t(
                'reportUsage.review.discrepancy.RowHeaderDesktop.itemDescription'
            ),
        },
        // {
        //     field: 'serialNo',
        //     width: '10%',
        //     header: 'Lot Serial',
        // },
        {
            field: 'quantity',
            header: t('reportUsage.summary.quantity'),
            width: '10%',
        },

        // {
        //     field: 'poNumber',
        //     header: 'PO',
        //     width: '12%',
        // },
        {
            field: 'unitPrice',
            header: t('orders.orderDetails.billingSummary.index.unitPrice'),
            width: '10%',
        },
        {
            field: 'extPrice',
            header: t('orders.orderDetails.billingSummary.index.extPrice'),
            width: '10%',
        },
        {
            field: 'status',
            header: t('orders.orderListView.statusLabel'),
            width: '12%',
        },
    ];

    colData = colData?.map((column) => {
        const extraProps = {
            bodyStyle: {},
        };
        switch (column.field) {
            case 'cfn':
                extraProps.headerStyle = {
                    padding: '0px 0px 0px 20px',
                    width: '30.5%',
                    height: '42px',
                };
                extraProps.bodyStyle = {
                    width: '30.5%',
                    padding: '5px 5px 5px 20px',
                };
                extraProps.body = (rowData) => {
                    const isBundle =
                        rowData?.isBundleHeader && rowData.isBundleHeader
                            ? rowData.isBundleHeader
                            : false;
                    return (
                        <>
                            <BundleLayout
                                isExpand={
                                    isBundle
                                        ? bundleArrowFunction(
                                              rowData.cfn,
                                              rowExpand
                                          )
                                        : false
                                }
                                bundleClickHandler={() => {
                                    try {
                                    rowToggleHandler(rowData, 'cfn', rowExpand);
                                    } catch (error) {
                                         logErrorToConsole(error);
                                     }
                                }}
                                isBundle={isBundle}
                            >
                                <UsagePricingDataContainer
                                    justifyContent="flex-start"
                                    flexDirection="column"
                                    alignItems="flex-start"
                                    height="100%"
                                >
                                    <UsagePricingDataContainer
                                        alignItems={'center'}
                                        justifyContent={'flex-start'}
                                        width={'100%'}
                                    >
                                        <CfnLabel
                                            cfnFontColor={isBundle && '#140F4B'}
                                            setItemHandler={setItemHandler}
                                            setDetailsData={rowData}
                                            cfn={rowData?.cfn && rowData.cfn}
                                            isShowSetItemDetails={
                                                !isBundle ? true : false
                                            }
                                            cursor={'pointer'}
                                            isBundle={isBundle}
                                        />
                                        {isBundle && (
                                            <BundleTag
                                                bundleFontOpacity={'0.92'}
                                                value={'Bundle'}
                                            />
                                        )}
                                    </UsagePricingDataContainer>

                                    <ItemDescriptionLabel
                                        // width="222px"
                                        textOverflow="ellipsis"
                                        overflow="hidden"
                                        lineClamp="2"
                                        orient="vertical"
                                        lineHeight="18px"
                                        color="#3C3C3C"
                                        fontSize="12px"
                                        display="-webkit-box"
                                        flexDirection="column"
                                        marginContainer={'5px 0 0 0'}
                                        descHeight={'38px'}
                                        description={
                                            rowData?.description &&
                                            rowData.description
                                        }
                                        isEquity
                                        brand={rowData?.brand?.[0]}
                                    />
                                </UsagePricingDataContainer>
                            </BundleLayout>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'serialNo':
                extraProps.headerStyle = {
                    //    padding: '0 0 0 2%',
                    width: '15.5%',
                    height: '42px',
                    textAlign: 'left',
                };

                extraProps.bodyStyle = {
                    width: '15.5%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <SerialNoLabel
                            serialNo={rowData?.serialNo && rowData.serialNo}
                            alignItemsContainer={'flex-start'}
                            justifyContentContiner={'flex-start'}
                            heightContainer={'100%'}
                            marginContainer={'0px'}
                            paddingContainer={'5px 0 0 0'}
                        />
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'status':
                extraProps.headerStyle = {
                    // display: 'none',
                    width: '17%',
                    height: '42px',
                    textAlign: 'left',
                    padding: '0px 25px 0px 5%',
                    textAlign: 'left',
                    padding: '0px 25px 0px 5%',
                };
                extraProps.bodyStyle = {
                    width: '17%',
                    padding: '0 25px 0 5.5%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                alignItems="flex-start"
                                justifyContent="flex-start"
                                height="100%"
                                padding={'5px 0 0 0'}
                                // margin={'0 0 0 8px'}
                            >
                                <UsagePricingTableFont
                                    lineHeight="23px"
                                    letterSpacing="-0.11px"
                                    textAlign={'left'}
                                >
                                    {rowData?.status && rowData.status}
                                </UsagePricingTableFont>
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'quantity':
                extraProps.headerStyle = {
                    // padding: '0 0 0 2%',
                    width: '10%',
                    height: '42px',
                    textAlign: 'left',
                };
                extraProps.bodyStyle = {
                    width: '10%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                // alignItems="flex-start"
                                // justifyContent="center"
                                height="100%"
                                padding={'5px 0 0 0'}
                            >
                                {rowData?.quantity && (
                                    <>
                                        <UsagePricingTableFont
                                            fontFamily={'AvenirNextWorld Demi'}
                                            color={'#202124'}
                                        >
                                            {`${
                                                rowData?.isUsed &&
                                                rowData.isUsed
                                                    ? t(
                                                          'reportUsage.review.discrepancy.Discrepancy.used'
                                                      )
                                                    : ''
                                            }`}
                                        </UsagePricingTableFont>
                                        <UsagePricingTableFont
                                            lineHeight="23px"
                                            letterSpacing="-0.11px"
                                            // margin={'0px 0px 0px 5px'}
                                        >
                                            {`${rowData.quantity} x ${rowData.uom}`}
                                        </UsagePricingTableFont>
                                    </>
                                )}
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'poNumber':
                extraProps.headerStyle = {
                    // padding: '0 0 0 2%',
                    width: '15%',
                    height: '42px',
                    textAlign: 'center',
                };
                extraProps.bodyStyle = {
                    width: '15%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                alignItems="flex-start"
                                justifyContent="center"
                                height="100%"
                                padding={'5px 0 0 0'}
                            >
                                <UsagePricingTableFont
                                    lineHeight="23px"
                                    letterSpacing="-0.11px"
                                    textAlign={'center'}
                                >
                                    {rowData?.poNumber && rowData.poNumber}
                                </UsagePricingTableFont>
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'unitPrice':
                extraProps.headerStyle = {
                    // padding: '0 0 0 2%',
                    width: '14.5%',
                    height: '42px',
                    textAlign: 'right',
                    paddingRight: '4px',
                };
                extraProps.bodyStyle = {
                    width: '14.5%',
                    paddingRight: '0',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <PricingContainer
                                // alignItemsContainer="flex-start"
                                paddingContainer={'5px 0 0 0'}
                                // marginContainer={'0 0 0 5.8rem'}
                                heightContainer={'100%'}
                                textAlign={'right'}
                                marginContainer={'0'}
                                price={rowData?.unitPrice && rowData.unitPrice}
                                subPrice={
                                    rowData?.overridenUnitPrice &&
                                    rowData.overridenUnitPrice
                                }
                            />
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'extPrice':
                extraProps.headerStyle = {
                    // padding: '0 0 0 2%',
                    width: '14.5%',
                    height: '42px',
                    textAlign: 'right',
                    paddingRight: '4px',
                };
                extraProps.bodyStyle = {
                    width: '14.5%',
                    paddingRight: '0',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <PricingContainer
                                alignItemsContainer="flex-end"
                                paddingContainer={'5px 0 0 0'}
                                marginContainer={'0'}
                                heightContainer={'100%'}
                                price={rowData?.extPrice && rowData.extPrice}
                                subPrice={
                                    rowData?.overridenExtPrice &&
                                    rowData.overridenExtPrice
                                }
                            />
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            default:
                return {
                    ...column,
                    ...extraProps,
                };
        }
    });

    let subColData = [
        {
            field: 'cfn',
            width: '27%',
            colSpan: '1',
        },
        // {
        //     field: 'serialNo',
        //     width: '10%',
        // },
        {
            field: 'quantity',
            width: '10%',
        },

        // {
        //     field: 'poNumber',
        //     width: '12%',
        // },
        {
            field: 'unitPrice',
            width: '10%',
        },
        {
            field: 'extPrice',
            width: '10%',
        },
        {
            field: 'status',
            header: 'Status',
            width: '12%',
        },
    ];

    subColData = subColData?.map((column) => {
        const extraProps = {
            bodyStyle: {},
        };
        switch (column.field) {
            case 'cfn':
                extraProps.headerStyle = {
                    display: 'none',
                };
                extraProps.bodyStyle = {
                    width: '34%',
                    padding: '0px 0px 0px 10px',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                justifyContent="flex-start"
                                flexDirection="column"
                                alignItems="flex-start"
                                height="100%"
                                padding={'15px 0'}
                            >
                                <CfnLabel
                                    setItemHandler={setItemHandler}
                                    setDetailsData={rowData}
                                    cfn={rowData?.cfn ? rowData.cfn : null}
                                    isShowSetItemDetails={true}
                                    cursor={'pointer'}
                                />

                                <ItemDescriptionLabel
                                    textOverflow="ellipsis"
                                    overflow="hidden"
                                    lineClamp="2"
                                    orient="vertical"
                                    lineHeight="18px"
                                    color="#3C3C3C"
                                    fontSize="12px"
                                    display="-webkit-box"
                                    marginContainer={'5px 0 0 0'}
                                    descHeight={'38px'}
                                    description={
                                        rowData?.description &&
                                        rowData.description
                                    }
                                    brand={rowData.brand}
                                />
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'serialNo':
                extraProps.headerStyle = {
                    display: 'none',
                    textAlign: 'left',
                    paddingRight: '35px',
                };

                extraProps.bodyStyle = {
                    width: '14%',
                    paddingRight: '33px',
                };
                extraProps.body = (rowData) => {
                    return (
                        <SerialNoLabel
                            serialNo={rowData?.serialNo && rowData.serialNo}
                            alignItemsContainer={'flex-start'}
                            justifyContentContiner={'flex-start'}
                            heightContainer={'100%'}
                            marginContainer={'0px'}
                            paddingContainer={'10px 0 0 0'}
                        />
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'quantity':
                extraProps.headerStyle = {
                    display: 'none',
                };
                extraProps.bodyStyle = {
                    width: '14%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                alignItems="flex-start"
                                justifyContent="flex-start"
                                height="100%"
                                padding={'5px 0 0 0'}
                            >
                                {rowData?.quantity && (
                                    <>
                                        {orderType != 'ZOR' && (
                                            <UsagePricingTableFont
                                                fontFamily={
                                                    'AvenirNextWorld Demi'
                                                }
                                                color={'#202124'}
                                            >
                                                {`${
                                                    rowData?.isUsed &&
                                                    rowData.isUsed
                                                        ? `${t(
                                                              'reportUsage.record.itemsList.QuantityInputBoxes.used'
                                                          )}:`
                                                        : `${t(
                                                              resolveAdjLabel(
                                                                  'reportUsage.itemList.other'
                                                              )
                                                          )}:`
                                                }`}
                                            </UsagePricingTableFont>
                                        )}
                                        <UsagePricingTableFont
                                            lineHeight="23px"
                                            letterSpacing="-0.11px"
                                            margin={
                                                orderType != 'ZOR' &&
                                                '0px 0px 0px 5px'
                                            }
                                        >
                                            {`${rowData.quantity} X ${rowData.uom}`}
                                        </UsagePricingTableFont>
                                    </>
                                )}
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'poNumber':
                extraProps.headerStyle = {
                    display: 'none',
                };
                extraProps.bodyStyle = {
                    width: '16%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                alignItems="flex-start"
                                justifyContent="center"
                                height="100%"
                                padding={'15px 0'}
                            >
                                <UsagePricingTableFont
                                    lineHeight="23px"
                                    letterSpacing="-0.11px"
                                    textAlign={'center'}
                                >
                                    {rowData?.poNumber && rowData.poNumber}
                                </UsagePricingTableFont>
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'unitPrice':
                extraProps.headerStyle = {
                    display: 'none',
                };
                extraProps.bodyStyle = {
                    width: '14.5%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <PricingContainer
                                alignItemsContainer="flex-start"
                                paddingContainer={'10px 0 0 0'}
                                marginContainer={'0'}
                                heightContainer={'100%'}
                                price={rowData?.unitPrice && rowData.unitPrice}
                                subPrice={
                                    rowData?.overridenUnitPrice &&
                                    rowData.overridenUnitPrice
                                }
                            />
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'extPrice':
                extraProps.headerStyle = {
                    display: 'none',
                };
                extraProps.bodyStyle = {
                    width: '14.5%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <PricingContainer
                                alignItemsContainer="flex-start"
                                paddingContainer={'10px 0 0 0'}
                                marginContainer={'0'}
                                heightContainer={'100%'}
                                price={rowData?.extPrice && rowData.extPrice}
                                subPrice={
                                    rowData?.overridenExtPrice &&
                                    rowData.overridenExtPrice
                                }
                            />
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            default:
                return {
                    ...column,
                    ...extraProps,
                };
        }
    });
    const rowToggleHandler = (e, key, expandRow) => {
        const updateExpandrow = bundleRowToggleFunction(e, key, expandRow);
        updateRowExpandHandler(updateExpandrow);
    };
    return (
        <UsagePricingDataTableContainer>
            <Datatable
                id={'orders-orderDetails-billingSummary-equity'}
                backgroundColorOdd={'#F5F5F599'}
                backgroundColorEven={'#FFFFFF99'}
                resizableColumns
                columns={colData}
                data={data}
                subColDatas={subColData}
                showSubTable={isBundleTable}
                keyValue={keyValue}
                bundleSubGroup={bundleSubGroup}
                expandRow={rowExpand}
                rowToggleHandler={rowToggleHandler}
                subTableWidth={'92%'}
            />
        </UsagePricingDataTableContainer>
    );
};

export default BillingSummaryDataTableEquity;
